export const environment = {
  production: true,
  apiUrl: 'https://demoapi.udruga.eu'
};